// automatically generated by the FlatBuffers compiler, do not modify
// @ts-nocheck

import * as flatbuffers from 'flatbuffers'
/**
 * @constructor
 */
export namespace JetStreamDataTile {
  export class Tile {
    bb: flatbuffers.ByteBuffer | null = null

    bb_pos: number = 0
    /**
     * @param number i
     * @param flatbuffers.ByteBuffer bb
     * @returns Tile
     */
    __init(i: number, bb: flatbuffers.ByteBuffer): Tile {
      this.bb_pos = i
      this.bb = bb
      return this
    }

    /**
     * @param flatbuffers.ByteBuffer bb
     * @param Tile= obj
     * @returns Tile
     */
    static getRootAsTile(bb: flatbuffers.ByteBuffer, obj?: Tile): Tile {
      return (obj || new Tile()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
    }

    /**
     * @param flatbuffers.ByteBuffer bb
     * @param Tile= obj
     * @returns Tile
     */
    static getSizePrefixedRootAsTile(bb: flatbuffers.ByteBuffer, obj?: Tile): Tile {
      bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
      return (obj || new Tile()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
    }

    /**
     * @param number index
     * @returns number
     */
    data(index: number): number | null {
      var offset = this.bb!.__offset(this.bb_pos, 4)
      return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0
    }

    /**
     * @returns number
     */
    dataLength(): number {
      var offset = this.bb!.__offset(this.bb_pos, 4)
      return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
    }

    /**
     * @returns Uint8Array
     */
    dataArray(): Uint8Array | null {
      var offset = this.bb!.__offset(this.bb_pos, 4)
      return offset
        ? new Uint8Array(
            this.bb!.bytes().buffer,
            this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
            this.bb!.__vector_len(this.bb_pos + offset)
          )
        : null
    }

    /**
     * @param flatbuffers.Builder builder
     */
    static startTile(builder: flatbuffers.Builder) {
      builder.startObject(1)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset dataOffset
     */
    static addData(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset) {
      builder.addFieldOffset(0, dataOffset, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param Array.<number> data
     * @returns flatbuffers.Offset
     */
    static createDataVector(builder: flatbuffers.Builder, data: number[] | Uint8Array): flatbuffers.Offset {
      builder.startVector(1, data.length, 1)
      for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i])
      }
      return builder.endVector()
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number numElems
     */
    static startDataVector(builder: flatbuffers.Builder, numElems: number) {
      builder.startVector(1, numElems, 1)
    }

    /**
     * @param flatbuffers.Builder builder
     * @returns flatbuffers.Offset
     */
    static endTile(builder: flatbuffers.Builder): flatbuffers.Offset {
      var offset = builder.endObject()
      return offset
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset offset
     */
    static finishTileBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
      builder.finish(offset)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset offset
     */
    static finishSizePrefixedTileBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
      builder.finish(offset, undefined, true)
    }

    static createTile(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset): flatbuffers.Offset {
      Tile.startTile(builder)
      Tile.addData(builder, dataOffset)
      return Tile.endTile(builder)
    }
  }
}
/**
 * @constructor
 */
export namespace JetStreamDataTile {
  export class MetaData {
    bb: flatbuffers.ByteBuffer | null = null

    bb_pos: number = 0
    /**
     * @param number i
     * @param flatbuffers.ByteBuffer bb
     * @returns MetaData
     */
    __init(i: number, bb: flatbuffers.ByteBuffer): MetaData {
      this.bb_pos = i
      this.bb = bb
      return this
    }

    /**
     * @param flatbuffers.ByteBuffer bb
     * @param MetaData= obj
     * @returns MetaData
     */
    static getRootAsMetaData(bb: flatbuffers.ByteBuffer, obj?: MetaData): MetaData {
      return (obj || new MetaData()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
    }

    /**
     * @param flatbuffers.ByteBuffer bb
     * @param MetaData= obj
     * @returns MetaData
     */
    static getSizePrefixedRootAsMetaData(bb: flatbuffers.ByteBuffer, obj?: MetaData): MetaData {
      bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
      return (obj || new MetaData()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
    }

    /**
     * @returns number
     */
    version(): number {
      var offset = this.bb!.__offset(this.bb_pos, 4)
      return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0
    }

    /**
     * @param flatbuffers.Encoding= optionalEncoding
     * @returns string|Uint8Array|null
     */
    type(): string | null
    type(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
    type(optionalEncoding?: any): string | Uint8Array | null {
      var offset = this.bb!.__offset(this.bb_pos, 6)
      return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
    }

    /**
     * @param flatbuffers.Encoding= optionalEncoding
     * @returns string|Uint8Array|null
     */
    id(): string | null
    id(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
    id(optionalEncoding?: any): string | Uint8Array | null {
      var offset = this.bb!.__offset(this.bb_pos, 8)
      return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
    }

    /**
     * @param number index
     * @returns number
     */
    zooms(index: number): number | null {
      var offset = this.bb!.__offset(this.bb_pos, 10)
      return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0
    }

    /**
     * @returns number
     */
    zoomsLength(): number {
      var offset = this.bb!.__offset(this.bb_pos, 10)
      return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
    }

    /**
     * @returns Uint8Array
     */
    zoomsArray(): Uint8Array | null {
      var offset = this.bb!.__offset(this.bb_pos, 10)
      return offset
        ? new Uint8Array(
            this.bb!.bytes().buffer,
            this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
            this.bb!.__vector_len(this.bb_pos + offset)
          )
        : null
    }

    /**
     * @returns number
     */
    width(): number {
      var offset = this.bb!.__offset(this.bb_pos, 12)
      return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
    }

    /**
     * @returns number
     */
    height(): number {
      var offset = this.bb!.__offset(this.bb_pos, 14)
      return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
    }

    /**
     * @returns number
     */
    channelCount(): number {
      var offset = this.bb!.__offset(this.bb_pos, 16)
      return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0
    }

    /**
     * @param number index
     * @returns number
     */
    altitudes(index: number): number | null {
      var offset = this.bb!.__offset(this.bb_pos, 18)
      return offset ? this.bb!.readFloat32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0
    }

    /**
     * @returns number
     */
    altitudesLength(): number {
      var offset = this.bb!.__offset(this.bb_pos, 18)
      return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
    }

    /**
     * @returns Float32Array
     */
    altitudesArray(): Float32Array | null {
      var offset = this.bb!.__offset(this.bb_pos, 18)
      return offset
        ? new Float32Array(
            this.bb!.bytes().buffer,
            this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
            this.bb!.__vector_len(this.bb_pos + offset)
          )
        : null
    }

    /**
     * @param number index
     * @returns flatbuffers.Long
     */
    timestamps(index: number): flatbuffers.Long | null {
      var offset = this.bb!.__offset(this.bb_pos, 20)
      return offset
        ? this.bb!.readUint64(this.bb!.__vector(this.bb_pos + offset) + index * 8)
        : this.bb!.createLong(0, 0)
    }

    /**
     * @returns number
     */
    timestampsLength(): number {
      var offset = this.bb!.__offset(this.bb_pos, 20)
      return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
    }

    /**
     * @param flatbuffers.Encoding= optionalEncoding
     * @returns string|Uint8Array|null
     */
    dataType(): string | null
    dataType(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
    dataType(optionalEncoding?: any): string | Uint8Array | null {
      var offset = this.bb!.__offset(this.bb_pos, 22)
      return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
    }

    /**
     * @returns number
     */
    fixedPointPrecision(): number {
      var offset = this.bb!.__offset(this.bb_pos, 24)
      return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0
    }

    /**
     * @param flatbuffers.Builder builder
     */
    static startMetaData(builder: flatbuffers.Builder) {
      builder.startObject(11)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number version
     */
    static addVersion(builder: flatbuffers.Builder, version: number) {
      builder.addFieldInt8(0, version, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset typeOffset
     */
    static addType(builder: flatbuffers.Builder, typeOffset: flatbuffers.Offset) {
      builder.addFieldOffset(1, typeOffset, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset idOffset
     */
    static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
      builder.addFieldOffset(2, idOffset, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset zoomsOffset
     */
    static addZooms(builder: flatbuffers.Builder, zoomsOffset: flatbuffers.Offset) {
      builder.addFieldOffset(3, zoomsOffset, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param Array.<number> data
     * @returns flatbuffers.Offset
     */
    static createZoomsVector(builder: flatbuffers.Builder, data: number[] | Uint8Array): flatbuffers.Offset {
      builder.startVector(1, data.length, 1)
      for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt8(data[i])
      }
      return builder.endVector()
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number numElems
     */
    static startZoomsVector(builder: flatbuffers.Builder, numElems: number) {
      builder.startVector(1, numElems, 1)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number width
     */
    static addWidth(builder: flatbuffers.Builder, width: number) {
      builder.addFieldInt16(4, width, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number height
     */
    static addHeight(builder: flatbuffers.Builder, height: number) {
      builder.addFieldInt16(5, height, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number channelCount
     */
    static addChannelCount(builder: flatbuffers.Builder, channelCount: number) {
      builder.addFieldInt8(6, channelCount, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset altitudesOffset
     */
    static addAltitudes(builder: flatbuffers.Builder, altitudesOffset: flatbuffers.Offset) {
      builder.addFieldOffset(7, altitudesOffset, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param Array.<number> data
     * @returns flatbuffers.Offset
     */
    static createAltitudesVector(builder: flatbuffers.Builder, data: number[] | Float32Array): flatbuffers.Offset
    /**
     * @deprecated This Uint8Array overload will be removed in the future.
     */
    static createAltitudesVector(builder: flatbuffers.Builder, data: number[] | Uint8Array): flatbuffers.Offset
    static createAltitudesVector(
      builder: flatbuffers.Builder,
      data: number[] | Float32Array | Uint8Array
    ): flatbuffers.Offset {
      builder.startVector(4, data.length, 4)
      for (var i = data.length - 1; i >= 0; i--) {
        builder.addFloat32(data[i])
      }
      return builder.endVector()
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number numElems
     */
    static startAltitudesVector(builder: flatbuffers.Builder, numElems: number) {
      builder.startVector(4, numElems, 4)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset timestampsOffset
     */
    static addTimestamps(builder: flatbuffers.Builder, timestampsOffset: flatbuffers.Offset) {
      builder.addFieldOffset(8, timestampsOffset, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param Array.<flatbuffers.Long> data
     * @returns flatbuffers.Offset
     */
    static createTimestampsVector(builder: flatbuffers.Builder, data: flatbuffers.Long[]): flatbuffers.Offset {
      builder.startVector(8, data.length, 8)
      for (var i = data.length - 1; i >= 0; i--) {
        builder.addInt64(data[i])
      }
      return builder.endVector()
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number numElems
     */
    static startTimestampsVector(builder: flatbuffers.Builder, numElems: number) {
      builder.startVector(8, numElems, 8)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param flatbuffers.Offset dataTypeOffset
     */
    static addDataType(builder: flatbuffers.Builder, dataTypeOffset: flatbuffers.Offset) {
      builder.addFieldOffset(9, dataTypeOffset, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @param number fixedPointPrecision
     */
    static addFixedPointPrecision(builder: flatbuffers.Builder, fixedPointPrecision: number) {
      builder.addFieldInt8(10, fixedPointPrecision, 0)
    }

    /**
     * @param flatbuffers.Builder builder
     * @returns flatbuffers.Offset
     */
    static endMetaData(builder: flatbuffers.Builder): flatbuffers.Offset {
      var offset = builder.endObject()
      return offset
    }

    static createMetaData(
      builder: flatbuffers.Builder,
      version: number,
      typeOffset: flatbuffers.Offset,
      idOffset: flatbuffers.Offset,
      zoomsOffset: flatbuffers.Offset,
      width: number,
      height: number,
      channelCount: number,
      altitudesOffset: flatbuffers.Offset,
      timestampsOffset: flatbuffers.Offset,
      dataTypeOffset: flatbuffers.Offset,
      fixedPointPrecision: number
    ): flatbuffers.Offset {
      MetaData.startMetaData(builder)
      MetaData.addVersion(builder, version)
      MetaData.addType(builder, typeOffset)
      MetaData.addId(builder, idOffset)
      MetaData.addZooms(builder, zoomsOffset)
      MetaData.addWidth(builder, width)
      MetaData.addHeight(builder, height)
      MetaData.addChannelCount(builder, channelCount)
      MetaData.addAltitudes(builder, altitudesOffset)
      MetaData.addTimestamps(builder, timestampsOffset)
      MetaData.addDataType(builder, dataTypeOffset)
      MetaData.addFixedPointPrecision(builder, fixedPointPrecision)
      return MetaData.endMetaData(builder)
    }
  }
}
